import { css } from '@emotion/react'
import { Text } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'
import theme from 'config/theme'

import { ConsultaSeguimentoPerguntaStatusTagEnum } from '../enums-consultaSeguimento'

interface ConsultaSeguimentoPerguntaStatusLabelProps {
  label: string
  status?: ConsultaSeguimentoPerguntaStatusTagEnum
}

export function ConsultaSeguimentoPerguntaStatusLabel(props: Readonly<ConsultaSeguimentoPerguntaStatusLabelProps>) {
  const { label, status = ConsultaSeguimentoPerguntaStatusTagEnum.DEFAULT } = props

  return <Text css={styles(status).label}>{label}</Text>
}

const styles = (status: ConsultaSeguimentoPerguntaStatusTagEnum) => ({
  label: css`
    height: 1.5rem;
    display: inline-flex;
    align-items: center;
    color: ${getColor(status)};
    font-weight: ${status === ConsultaSeguimentoPerguntaStatusTagEnum.DEFAULT ? 'normal' : 'bold'};
  `,
})

const getColor = (status: ConsultaSeguimentoPerguntaStatusTagEnum): string => {
  if (status === ConsultaSeguimentoPerguntaStatusTagEnum.DEFAULT) {
    return theme.pallete.text.main
  } else if (status === ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU) {
    return green.c30
  } else {
    return red.c30
  }
}
